import React, { FC, useState, useEffect } from 'react'
import Alert from '@vtex/styleguide/lib/Alert'
import {
  ScenarioType,
  CartMessage,
  CartDisplayMessage,
} from '@/checkout-instore-legacy/cart/message/types'
import { toCartDisplayMessage } from '@/checkout-instore-legacy/cart/message/factories'
import isNil from 'lodash/isNil'

const toAlertType = (scenarioType: ScenarioType) => {
  switch (scenarioType) {
    case ScenarioType.UNEXPECTED:
      return 'warning'
    case ScenarioType.PENDENCY:
      return 'error'
    default:
      return 'warning'
  }
}

interface CartAlertMessageProps {
  cartMessage: CartMessage
}

const CartAlertMessage: FC<CartAlertMessageProps> = ({ cartMessage }) => {
  const [
    cartDisplayMessage,
    setCartDisplayMessage,
  ] = useState<CartDisplayMessage>()
  useEffect(() => {
    setCartDisplayMessage(toCartDisplayMessage(cartMessage))
  }, [cartMessage])
  if (isNil(cartDisplayMessage)) {
    return null
  }

  const alertType = toAlertType(cartDisplayMessage.scenario)
  return (
    <div className="mt5" data-testid="alert-message">
      <Alert type={alertType} action={cartDisplayMessage.action}>
        {cartDisplayMessage.label}
      </Alert>
    </div>
  )
}

export default CartAlertMessage
